import { Base } from "ui/Scripts/source/framework/base";
import { ITaskEditItem, TaskEditItem } from "./taskEditItem";
import { ITaskStateItem, TaskStateItem } from "./taskStateItem";
import { ITaskEditPriorityItem, TaskEditPriorityItem } from "./taskEditPriorityItem";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { IUnitItem, UnitItem } from "../unit/unitItem";
import { TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { EnumHelper, TaskRepetitionType } from "ui/Scripts/source/models/enums";
import { TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";

export interface ITaskEdit {
    item: ITaskEditItem;
    taskTypes: ITaskEditTypeItem[];
    taskStates: ITaskStateItem[];
    taskPriorities: ITaskEditPriorityItem[];
    units: IUnitItem[];
    userCompanyId: string;
    userCode: string;
    userName: string;
    userPicture: string;
    canHandleTask: boolean;
    canRemoveTask: boolean;
    canChangeTaskState: boolean;
    userIsIsSystemAdmin: boolean;
}

export class TaskEdit implements ITaskEdit {
    item: TaskEditItem;
    taskTypes: TaskEditTypeItem[];
    taskStates: TaskStateItem[];
    taskPriorities: TaskEditPriorityItem[];
    units: UnitItem[];
    userCompanyId: string;
    userCode: string;
    userName: string;
    userPicture: string;
    canHandleTask: boolean;
    canRemoveTask: boolean;
    canChangeTaskState: boolean;
    userIsIsSystemAdmin: boolean;

    constructor();
    constructor(obj: ITaskEdit);
    constructor(obj?: any) {
        this.item = null;
        if (obj && obj.item) {
            this.item = new TaskEditItem(obj.item);
        }
        this.userCompanyId = obj && obj.userCompanyId || "";
        this.userCode = obj && obj.userCode || "";
        this.userName = obj && obj.userName || "";
        this.userPicture = obj && obj.userPicture || "";
        this.canHandleTask = obj && obj.canHandleTask && obj.canHandleTask === true;
        this.canRemoveTask = obj && obj.canRemoveTask && obj.canRemoveTask === true;
        this.canChangeTaskState = obj && obj.canChangeTaskState && obj.canChangeTaskState === true;
        this.userIsIsSystemAdmin = obj && obj.userIsIsSystemAdmin && obj.userIsIsSystemAdmin === true;
        this.taskTypes = Base.getTypedArray<TaskEditTypeItem>(obj ? obj.taskTypes : null, TaskEditTypeItem);
        this.taskStates = Base.getTypedArray<TaskStateItem>(obj ? obj.taskStates : null, TaskStateItem);
        this.taskPriorities = Base.getTypedArray<TaskEditPriorityItem>(obj ? obj.taskPriorities : null, TaskEditPriorityItem);
        this.units = Base.getTypedArray<UnitItem>(obj ? obj.units : null, UnitItem);
        const taskType = this.taskTypes.find(i => i.id === this.item.taskTypeId);
        this.item.taskHeaderDataCols = TaskDataRowCol.initializeValuesByType(taskType.headerCols, this.item.taskHeaderDataCols);
        if (EnumHelper.isEqual(taskType.taskRepetitionType, TaskRepetitionType.NotRepeated) && this.item.taskDataRows.length < 0) {
            this.item.taskDataRows.push(new TaskDataRow());
        }
        this.item.initializeTaskDataRows(taskType);
    }
}